import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/img/logo.png";

class Footercontent extends Component {
  render() {
    return (
      <Fragment>
        {/* Middle Footer */}
        <div className="sigma_footer-middle"  style={{color: "black !important"}}>
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
                <img src={logo} className="mb-1" alt="" />
                <p>Kamla Heights, Paithankar Road, Itwari, Nagpur- 02, M.H. India </p>
                <ul className="sigma_sm">
                  <li>
                    {" "}
                    <Link to="https://www.facebook.com/gemsgnine">
                      {" "}
                      <i className="fab fa-facebook-f" />{" "}
                    </Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="https://www.instagram.com/gemsgnine">
                      {" "}
                      <i className="fab fa-instagram" />{" "}
                    </Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="https://wa.me/918928330046">
                      {" "}
                      <i className="fab fa-whatsapp" />{" "}
                    </Link>{" "}
                  </li>
                </ul>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
                <h5 className="widget-title">Contact Us</h5>
                <ul>
                  <li>
                    <i class="pe-7s-mail"></i>{" "}
                    <a href="mailto:gemsgnine@gmail.com">
                      gemsgnine@gmail.com{" "}
                    </a>
                  </li>
                  <li>
                    <i class="pe-7s-call"></i>{" "}
                    <a href="tel:+918928330046">+918928330046</a>
                  </li>
                  <li>
                    <i class="pe-7s-map-2"></i>{" "}
                    <a href="https://goo.gl/maps/m2w4KRgPkchCmuim8">
                      {" "}
                      Location
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
                <h5 className="widget-title">Information</h5>
                <ul>
                  <li>
                    {" "}
                    <Link to="/terms">Terms & Conditions</Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="/privacy">Privacy Policy</Link>{" "}
                  </li>
                  
                </ul>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 d-none d-lg-block footer-widget">
                <h5 className="widget-title">Quick Links</h5>
                <ul>
                  <li>
                    {" "}
                    <Link to="/about">About Us</Link>{" "}
                  </li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Bottom */}
        <div className="sigma_footer-bottom">
          <div className="container">
            <div className="sigma_footer-copyright">
              <p> Copyright © 2022. All Rights Reserved. </p>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Footercontent;
